// The nav item after the one containing `from`, crossing into the next list
// when needed. Flyouts and panels render in a portal at the end of the body,
// so the browser's own Tab order would leave the nav from them.
export function findNextNavFocusable(from: Element | null): HTMLElement | null {
  const currentLi = from?.closest("li");
  if (!currentLi) return null;

  let nextLi = currentLi.nextElementSibling;
  while (nextLi) {
    const focusable = nextLi.querySelector<HTMLElement>("button, a");
    if (focusable) return focusable;
    nextLi = nextLi.nextElementSibling;
  }

  const currentList = currentLi.closest("ul");
  if (!currentList) return null;

  let nextList = currentList.nextElementSibling;
  while (nextList) {
    if (nextList.tagName === "UL") {
      const focusable = nextList.querySelector<HTMLElement>("button, a");
      if (focusable) return focusable;
    }
    nextList = nextList.nextElementSibling;
  }

  return null;
}
